import { PageHeader, Loading } from "@/components/Common";
import { RetPill, RetLink, orderOf } from "@/components/returns/RetCommon";
import { useLoad } from "@/hooks/useData";
import { api } from "@/lib/api";
import { dateLabel, fmtINR } from "@/lib/format";

const Tile = ({ label, value, testid, tone = "" }) => (
  <div className="panel p-4"><div className="text-[10px] font-bold uppercase tracking-widest text-muted-foreground">{label}</div>
    <div className={`mt-2 font-mono text-2xl font-extrabold ${tone}`} data-testid={testid}>{value}</div></div>
);

export default function Claims() {
  const { data } = useLoad(() => api.get("/returns-claims").then((r) => r.data), []);
  if (!data) return <Loading />;
  return (
    <div data-testid="claims-page">
      <PageHeader title="Claims" subtitle="Damaged, lost or claimed returns with Amazon SAFE-T or the courier." />
      <div className="mb-4 grid grid-cols-2 gap-3 sm:grid-cols-4">
        <Tile label="Cases" value={data.count} testid="claims-count" />
        <Tile label="Claimed ₹" value={fmtINR(data.claimed)} testid="claims-claimed" tone="text-purple-700" />
        <Tile label="Settled ₹" value={fmtINR(data.settled)} testid="claims-settled" tone="text-emerald-600" />
        <Tile label="Open ₹" value={fmtINR(data.open)} testid="claims-open" tone="text-red-600" />
      </div>
      <div className="panel overflow-x-auto">
        <table className="data-table" data-testid="claims-table">
          <thead><tr><th>Return</th><th>Date</th><th>Order</th><th>Product</th><th>Type / condition</th><th>Raised with</th><th>Claim ID</th><th className="text-right">Claimed</th><th className="text-right">Settled</th><th>Claim status</th><th>Case</th></tr></thead>
          <tbody>{data.rows.map((r) => (
            <tr key={r.id}><td><RetLink r={r} /></td><td className="text-xs">{dateLabel(r.return_date)}</td><td className="font-mono text-xs">{orderOf(r)}</td>
              <td><div className="max-w-[200px] truncate text-xs">{r.product_name}</div></td><td className="text-xs">{r.return_type || "—"} · {r.condition || "—"}</td>
              <td className="text-xs">{r.claim_raised_with || "—"}</td><td className="font-mono text-xs">{r.claim_id}</td>
              <td className="num">{r.claim_amount ? fmtINR(r.claim_amount) : "—"}</td><td className="num">{r.claim_settled ? fmtINR(r.claim_settled) : "—"}</td>
              <td className="text-xs">{r.claim_status || "Not Raised"}</td><td><RetPill status={r.status} /></td></tr>))}</tbody>
        </table>
      </div>
    </div>
  );
}
